<header class="platform-header">
	<div class="platform-header__main">
		<div class="platform-header__titles">
			<h2 class="platform-header__title">{{ title }}</h2>
			<p class="platform-header__subtitle" *ngIf="showSubtitle && subtitle">{{ subtitle }}</p>
		</div>

		<div class="platform-header__actions">
			<div class="platform-header__search">
				<input
					type="text"
					class="platform-header__search-input"
					placeholder="Consultar"
					aria-label="Consultar"
					aria-autocomplete="list"
					[attr.aria-expanded]="searchDropdownOpen && hasSearchOptions"
					(input)="onSearchInput($event)"
					(focus)="onSearchFocus()" />
				<b3-icon name="search" class="platform-header__search-icon"></b3-icon>

				<div
					class="platform-header__search-dropdown"
					*ngIf="searchDropdownOpen && hasSearchOptions && filteredSearchGroups.length"
					role="listbox"
					aria-label="Resultados da busca">
					<ng-container
						*ngFor="let group of filteredSearchGroups; let last = last; trackBy: trackSearchGroup">
						<div class="platform-header__search-group">
							<p class="platform-header__search-group-title">{{ group.title }}</p>
							<button
								type="button"
								class="platform-header__search-item"
								*ngFor="let item of group.items; trackBy: trackSearchItem"
								role="option"
								[attr.aria-label]="'Ir para ' + item.label"
								(click)="onSearchItemClick(item, $event)">
								<span class="platform-header__search-item-icon" aria-hidden="true">
									<b3-icon [name]="item.icon" tone="neutral"></b3-icon>
								</span>
								<span class="platform-header__search-item-label">{{ item.label }}</span>
							</button>
						</div>
						<div class="platform-header__search-group-divider" *ngIf="!last" aria-hidden="true"></div>
					</ng-container>
				</div>
			</div>

			<div class="platform-header__user-area">
				<button
					type="button"
					class="platform-header__user-btn"
					aria-label="Menu do usuário"
					aria-haspopup="menu"
					[attr.aria-expanded]="userMenuOpen"
					(click)="onUserMenuClick($event)">
					<span class="platform-header__avatar">{{ userInitials }}</span>
					<b3-icon name="keyboard_arrow_down" class="platform-header__user-chevron"></b3-icon>
				</button>

				<div class="platform-header__user-menu" *ngIf="userMenuOpen" role="menu" aria-label="Menu do usuário">
					<div class="platform-header__user-menu-header" role="presentation">
						<span class="platform-header__user-menu-avatar" aria-hidden="true">{{ userInitials }}</span>
						<p class="platform-header__user-menu-name">{{ userDisplayName }}</p>
					</div>
					<button type="button" class="platform-header__user-menu-item" role="menuitem" (click)="onLogout($event)">
						<b3-icon name="logout" class="platform-header__user-menu-item-icon"></b3-icon>
						<span>Sair</span>
					</button>
				</div>
			</div>
		</div>
	</div>

	<div class="platform-header__divider" aria-hidden="true"></div>
</header>
